module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAFBAMAAACDVBAcAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAMFBMVEUAAACvr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr68AAABH4Z0qAAAADnRSTlMAaPr7Q+0l19gRuQSTlPLWDecAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAABYktHRACIBR1IAAAAKklEQVQY02NgYNh7GkgwcK57NQFIZbx7V8bAwBL37t1TBwbhd+/evVMEAMSIDcPx3KDoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/global/type-arrows/up-grey5.png
// module id = 794
// module chunks = 0 1 2 3 4